import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Scaffold from './components/layout/Scaffold';
import SignupBusinessPage from './pages/SignupBusinessPage';
import LoginPage from './pages/LoginPage';
// ... import other components ...
import VerificationCodePage from './pages/VerificationCodePage';
import CreateStore from './pages/CreateStore';
import CreateCatalogs from './pages/CreateCatalogs';
import CreateCategories from './pages/CreateCategories';
import CreateProductItem from './pages/CreateProductItem';
import CreatePackageItem from './pages/CreatePackageItem';
import PointOfSale from './pages/PointOfSale';
import ImportData from './pages/ImportData';
import Accounting from './pages/Accounting';
import AccountType from './pages/AccountType';
import MappingManager from './pages/MappingManager';
import NewAccount from './pages/NewAccount';
import NewCustomer from './pages/NewCustomer';
import CreateStoreTaxes from './pages/CreateStoreTaxes';
import CreateRoles from './pages/CreateRoles';
import { ToastProvider } from './context/ToastContext';
import NewStaffMember from './pages/NewStaffMember';
import ConfirmUser from './pages/ConfirmUser';
import PaystackBankTransferForm from './pages/PaystackBankTransferForm';
import StaffToStore from './pages/StaffToStore';
import VendorManagement from './pages/VendorManagement';
import PurchaseOrderManagement from './pages/PurchaseOrderManagement';
import VendorPurchaseOrders from './pages/VendorPurchaseOrders';
import VendorGoodsReceipt from './pages/VendorGoodsReceipt';
import AccountDetailsPage from './pages/AccountDetails';
import ResetPasswordPage from './pages/ResetPassword';
import Inventory from './pages/Inventory';
import DiscountManager from './pages/DiscountManager';
import NewJournalEntry from './pages/NewJournalEntry';
import Users from './pages/Users';
import Creditline from './pages/Creditline';
import Stores from './pages/Stores';
import ProductCatalogs from './pages/ProductCatalogs';
import InventoryAnalytics from './pages/InventoryAnalytics';
import MainReportsDashboard from './pages/MainReportsDashboard';
import StoreDetails from './pages/StoreDetails';
import CustomerReturns from './pages/CustomerReturns';
import OrderDetails from './pages/OrderDetails';
import ReportTemplate from './pages/ReportTemplate';
import CustomerLedgerReport from './pages/CustomerLedgerReport';
import EditAccount from './pages/EditAccount';
import Chat from './pages/Chat';
import StockHistory from './pages/StockHistory';
import ViewCatentryDetails from './pages/ViewCatentryDetails';
import CustomerList from './pages/CustomerList';
import AccountLedgerPage from './pages/AccountLedgerPage';
import CreditSales from './pages/CreditSales';
import InventoryTransferManager from './pages/InventoryTransferManager';
import NewCustomerDetails from './pages/NewCustomerDetails';
import ItemDetails from './pages/ItemDetails';
import EditProductItem from './pages/EditProductItem';
import NewInvoice from './pages/NewInvoice';
import NewReceipt from './pages/NewReceipt';
import Invoices from './pages/Invoices';
import VoidedInvoices from './pages/VoidedInvoices';
import ReceivePayment from './pages/ReceivePayment';
import InvoiceDetails from './pages/InvoiceDetails';
import NewCreditNote from './pages/NewCreditNote';
import InventoryLots from './pages/InventoryLot';
import Receipts from './pages/Receipts';
import ReceiptDetails from './pages/ReceiptDetails';
import AccountingReports from './pages/AccountingReports';
import PaymentsReceived from './pages/PaymentsReceived';
import EndOfDaySalesReport from './pages/EndOfDaySalesReport';
import FastTrackRestock from './pages/FastTrackRestock';
import SalesPerformanceReport from './pages/SalesPerformanceReport';
import GeneralLedgerReport from './pages/GeneralLedgerReport';
import GeneralJournalReport from './pages/GeneralJournalReport';
import AccountLedgerReport from './pages/AccountLedgerReport';
import ReturnToVendor from './pages/ReturnToVendor';
import LedgerSummaryReport from './pages/LedgerSummaryReport';
import InventoryValuationDashboard from './pages/InventoryValuationDashboard';
import GoodsReceiptHistory from './pages/GoodsReceiptHistory';
import ExpenseReport from './pages/ExpenseReport';
import TrialBalanceReport from './pages/TrialBalanceReport';
import SalesReport from './pages/SalesReport';
import InventoryClosingReport from './pages/InventoryClosingReport';
import NewStockHistory from './pages/NewStockHistory';
import PNLReport from './pages/PNLReport';
import VendorGoodsReceiptWithoutPayment from './pages/VendorGoodsReceiptWithoutPayment';
import EditVendorGoodsReceiptWithoutPayment from './pages/EditVendorGoodsReceiptWithoutPayment';
import GoodsReceiptApproval from './pages/GoodsReceiptApproval';
import VendorSubledgerReport from './pages/VendorSubledgerReport';
import MainDashboard from './pages/Dashboard';
import BranchManagement from './pages/BranchManagement';
import EditStore from './pages/EditStore';
import CustomerManagement from './pages/CustomerManagement';
import GroupMemberManager from './pages/GroupMemberManager';
import NewAccounting from './pages/NewAccounting';
import NewTrialBalanceReport from './pages/NewTrialBalance';
import NewPNLReport from './pages/NewPNLReport';
import TransactionCorrectionManager from './pages/TransactionCorrectionManager';
import UserProfile from './pages/UserProfile';
import ExpenseLogging from './pages/Expenses';
import SubscriptionPartialPaymentNotification from './pages/SubscriptionPartialPaymentNotification';
import StoreAccountMapping from './pages/StoreAccountMapping';
import SeerbitPocketManager from './pages/SeerbitPocketManager';
import EmployeeProfilesManager from './pages/EmployeeProfilesManager';
import PayrollMakerManager from './pages/PayrollMakerManager';
import PayrollCheckerManager from './pages/PayrollCheckerManager';
import WalletExpenses from './pages/WalletExpenses';
import NewBalanceSheetReport from './pages/NewBalanceSheetReport';
import EditCustomerDetails from './pages/EditCustomerDetails';
import SalesReportV2 from './pages/SalesReportV2';
import ForgotPasswordPage from './pages/ForgotPassword';
import CreditSaleApprovals from './pages/CreditSaleApprovals';
import PendingCashDeposits from './pages/PendingCashDeposits';

function App() {
    return (
        <Router>
            <ToastProvider>
                <Routes>
                    {/* 👇️ NEW: Index Route (/) - Outside Scaffold (Public) */}
                    <Route path="/" element={<LoginPage />} />
                    {/* Public routes (no Scaffold layout) */}
                    <Route path="/signup-business" element={<SignupBusinessPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/login-verification" element={<VerificationCodePage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password/:salt" element={<ResetPasswordPage />} />
                    <Route path="/change-password/:salt" element={<ResetPasswordPage />} />
                    <Route path="/confirmuser/:salt" element={<ConfirmUser />} />
                    {/* The rest of the pages that should not use Scaffold (if any) */}
                    <Route path="/bank-transfer" element={<PaystackBankTransferForm />} />

                    {/* Routes that use the Scaffold layout */}
                    <Route path="/*" element={<Scaffold />}>
                        {/* The old index route: <Route index element={<LoginPage />} /> 
                            is now outside the Scaffold route and should be removed from here.
                        */}

                        {/* Default route for the dashboard, will be replaced later */}
                        <Route path="dashboard">
                            {/* <Route index element={<InventoryAnalytics />} /> */}
                            <Route index element={<MainDashboard />} />
                        </Route>
                        <Route path="chat">
                            <Route index element={<Chat />} />
                        </Route>
                        <Route path="discount">
                        </Route>
                        {/* Nested routes for stores */}
                        <Route path="branches">
                            {/* <Route index element={<Stores />} /> */}
                            <Route index element={<BranchManagement />} />
                            <Route path="staff-to-branch" element={<StaffToStore />} />
                            <Route path="manage-discount" element={<DiscountManager />} />
                            <Route path="create" element={<CreateStore />} />
                            <Route path="edit" element={<EditStore />} />
                            <Route path="details" element={<StoreDetails />} />
                            <Route path="customer-return" element={<CustomerReturns />} />
                            <Route path="spec-branch-tax" element={<CreateStoreTaxes />} />
                            {/* <Route path=":storeId/edit" element={<EditStore />} /> */}
                        </Route>
                        {/* Nested routes for catalogs */}
                        {/* (kept commented routes for context) */}

                        {/* Nested routes for products */}
                        <Route path="catalog">
                            <Route index element={<ProductCatalogs />} />
                            <Route path="item-details" element={<ItemDetails />} />
                            <Route path="create-catalogs" element={<CreateCatalogs />} />
                            <Route path="create-categories" element={<CreateCategories />} />
                            <Route path="create-item" element={<CreateProductItem />} />
                            <Route path="edit-item" element={<EditProductItem />} />
                            <Route path="create-package" element={<CreatePackageItem />} />
                            <Route path="view-details" element={<ViewCatentryDetails />} />
                        </Route>
                        {/* Accounting routes - now direct children of Scaffold's routes */}
                        <Route path="accounting">
                            {/* <Route index element={<Accounting />} /> */}
                            {/* <Route path="coa" element={<Accounting />} /> */}
                            <Route index element={<NewAccounting />} />
                            <Route path="coa" element={<NewAccounting />} />
                            <Route path="store-account-mapping" element={<StoreAccountMapping />} />
                            <Route path="new-account" element={<NewAccount />} />
                            <Route path="new-journal-entry" element={<NewJournalEntry />} />
                            <Route path="accounttype" element={<AccountType />} />
                            <Route path="mapping-manager" element={<MappingManager />} />
                            <Route path="details" element={<AccountDetailsPage />} />
                            <Route path="ledger" element={<AccountLedgerPage />} />
                            <Route path="edit" element={<EditAccount />} />
                            <Route path="order-details" element={<OrderDetails />} />
                            <Route path="transactions" element={<TransactionCorrectionManager />} />
                            <Route path="expenses" element={<ExpenseLogging />} />
                            <Route path="pending-deposits" element={<PendingCashDeposits />} />
                        </Route>
                        <Route path="wallet">
                            <Route index element={<SeerbitPocketManager />} />
                            <Route path="virtual-wallet" element={<SeerbitPocketManager />} />
                            <Route path="payroll-management" element={<EmployeeProfilesManager />} />
                            <Route path="payroll-maker" element={<PayrollMakerManager />} />
                            <Route path="payroll-checker" element={<PayrollCheckerManager />} />
                            <Route path="wallet-expenses" element={<WalletExpenses />} />
                        </Route>
                        <Route path="sales">
                            <Route index element={<PointOfSale />} />
                            <Route path="pos" element={<PointOfSale />} />
                            <Route path="credit-sale-approvals" element={<CreditSaleApprovals />} />
                            {/* <Route path="customers" element={<CustomerList />} /> */}
                            <Route path="customers" element={<CustomerManagement />} />
                            <Route path="group/members" element={<GroupMemberManager />} />
                            <Route path="discounts" element={<DiscountManager />} />
                            <Route path="invoices" element={<Invoices />} />
                            <Route path="receipts" element={<Receipts />} />
                            <Route path="voided-invoices" element={<VoidedInvoices />} />
                            {/* <Route path="returns" element={<CustomerReturns />} /> */}
                            <Route path="payments" element={<PaymentsReceived />} />
                            <Route path="invoices/view" element={<InvoiceDetails />} />
                            <Route path="receipts/view" element={<ReceiptDetails />} />
                            <Route path="customers/line-of-credit" element={<Creditline />} />
                            <Route path="customers/new" element={<NewCustomerDetails />} />
                            <Route path="customers/edit" element={<EditCustomerDetails />} />
                            <Route path="invoices/new" element={<NewInvoice />} />
                            <Route path="credit-notes/new" element={<NewCreditNote />} />
                            <Route path="invoices/receive-payment" element={<ReceivePayment />} />
                            <Route path="receipts/new" element={<NewReceipt />} />
                        </Route>
                        <Route path="import-data" element={<ImportData />} />
                        <Route path="roles">
                            <Route index element={
                                <div className="flex items-center justify-center h-full"> <h2 className="text-gmail-green text-3xl font-bold p-4">Roles List Page Placeholder</h2> </div>
                            } />
                            <Route path="create" element={<CreateRoles />} /> {/* New Create Roles Page route */}
                        </Route>
                        <Route path="vendor">
                            <Route index element={<VendorManagement />} />
                            <Route path="list" element={<VendorManagement />} />
                            <Route path="create-purchase-orders" element={<PurchaseOrderManagement />} />
                            <Route path="view-purchase-orders" element={<VendorPurchaseOrders />} />
                            <Route path="vendor-goods-receipt" element={<VendorGoodsReceiptWithoutPayment />} />
                            <Route path="edit-vendor-goods-receipt" element={<EditVendorGoodsReceiptWithoutPayment />} />
                            <Route path="return-to-vendor" element={<ReturnToVendor />} />
                            <Route path="fast-restock" element={<FastTrackRestock />} />
                            <Route path="approve-vendor-goods-receipt" element={<GoodsReceiptApproval />} />
                        </Route>
                        <Route path="inventory">
                            <Route index element={<Inventory />} />
                            <Route path="index" element={<Inventory />} />
                            <Route path="inventory-transfer" element={<InventoryTransferManager />} />
                            <Route path="lots" element={<InventoryLots />} />
                        </Route>
                        <Route path="settings">
                            <Route index element={<Users />} />
                            <Route path="user-profile" element={<UserProfile />} />
                            <Route path="new-customer" element={<NewCustomer />} />
                            <Route path="invite-staff" element={<NewStaffMember />} /> {/* New Invite Staff Page route */}
                        </Route>
                        <Route path="reports">
                            {/* <Route index element={<MainReportsDashboard />} /> */}
                            <Route index element={<AccountingReports />} />
                            {/* <Route index element={<SubscriptionPartialPaymentNotification />} />
                            <Route path="*" element={<SubscriptionPartialPaymentNotification />} /> */}

                            <Route path="general-ledger-report" element={<LedgerSummaryReport />} />
                            <Route path="general-ledger-trial-balance" element={<NewTrialBalanceReport />} />
                            <Route path="balance-sheet-report" element={<NewBalanceSheetReport />} />
                            <Route path="vendor-ledger-report" element={<VendorSubledgerReport />} />
                            <Route path="general-journal-report" element={<GeneralJournalReport />} />
                            <Route path="customer-list" element={<CustomerManagement />} />
                            <Route path="customer-report" element={<CustomerLedgerReport />} />
                            <Route path="report-template" element={<ReportTemplate />} />
                            <Route path="stock-history" element={<StockHistory />} />
                            <Route path="eod-sales-report" element={<EndOfDaySalesReport />} />
                            <Route path="sales-performance" element={<SalesPerformanceReport />} />
                            <Route path="account-ledger-report" element={<AccountLedgerReport />} />
                            <Route path="inventory-valuation-report" element={<InventoryValuationDashboard />} />
                            <Route path="goods-receipt-history" element={<GoodsReceiptHistory />} />
                            <Route path="expense-report" element={<ExpenseReport />} />
                            <Route path="sales-report" element={<SalesReport />} />
                            <Route path="sales-report-v2" element={<SalesReportV2 />} />
                            <Route path="new-stock-history" element={<NewStockHistory />} />
                            <Route path="profit-and-loss" element={<NewPNLReport />} />
                            <Route path="inventory-closing-report" element={<InventoryClosingReport />} />
                        </Route>
                    </Route>
                </Routes>
            </ToastProvider>
        </Router>
    );
}

export default App;


// sawa box 
// pp 20
// 